var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMailYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7428 6.99963C12.108 7.22922 12.5411 7.36227 13.0055 7.36488C13.4699 7.36488 13.9029 7.23443 14.2708 7.00746L25.0976 0.320893C24.8237 0.127835 24.5133 0 24.1924 0H1.82119C1.52116 0 1.2368 0.112182 0.978516 0.27915L11.7428 6.99963Z",
    fill: "#FCC800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2676 8.79975C13.9023 9.02933 13.4667 9.15978 13.0023 9.15978C12.5379 9.15978 12.1048 9.02672 11.737 8.79714L0.21875 1.62793V16.7803C0.21875 17.1899 0.375283 17.5995 0.68574 17.91C0.996197 18.2204 1.40579 18.377 1.81539 18.377H24.1866C24.5962 18.377 25.0058 18.2204 25.3162 17.91C25.6267 17.5995 25.7832 17.1899 25.7832 16.7803V1.63837L14.2676 8.79975Z",
    fill: "#FCC800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMailYellow);
export default __webpack_public_path__ + "static/media/icon_mail_yellow.866f5e61c8336715e94c679cfc040ff5.svg";
export { ForwardRef as ReactComponent };